import { useState } from 'react'

import { Button, ShareDrawer } from '@hhgtech/hhg-components'
import { Container, Flex, SimpleGrid, Stack } from '@mantine/core'
import { useIntl } from 'react-intl'

// import Share from 'components/atoms/icons/Share'
import { SharePopupNew } from 'components/organisms/sharePopupNew'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { DataTrackingTypeHTMLElement } from 'interfaces/types'

import { showNotification } from '../notificationsHandler'

type HealthToolButtonGroupProps = {
  toolLink: string
  saveLabel?: string
  onRecalculate(): void
  onSave?(): void
  tracking?: {
    save: DataTrackingTypeHTMLElement
    reCalculate: DataTrackingTypeHTMLElement
    share: DataTrackingTypeHTMLElement
  }
}

const HealthToolButtonGroup = ({
  toolLink,
  onRecalculate,
  onSave,
  saveLabel,
  tracking,
}: HealthToolButtonGroupProps) => {
  const isMobile = useIsMobile()
  const { locale } = useRouterExtend()
  const { formatMessage: f } = useIntl()

  const [isShareOpen, setIsShareOpen] = useState(false)
  // const onShare = () => {
  //   if (isMobile) {
  //     setIsShareOpen(true)
  //   }
  // }

  const onCopied = () => {
    showNotification({
      type: 'success',
      title: 'Success',
      message: 'Link copied successfully',
    })
  }

  return (
    <>
      <ShareDrawer
        locale={locale}
        url={toolLink}
        open={isShareOpen}
        onClose={() => setIsShareOpen(false)}
        onCopied={onCopied}
        onShared={() => setIsShareOpen(false)}
      />
      {isMobile ? (
        <Container fluid px={0}>
          <Stack>
            {onSave && (
              <Button
                size="lg"
                color="primary"
                onClick={onSave}
                {...tracking?.save}
              >
                {saveLabel || 'Save'}
              </Button>
            )}
            <Button
              style={{ width: '100%' }}
              size="lg"
              color="secondary"
              onClick={onRecalculate}
              {...tracking?.reCalculate}
            >
              {f({
                id: 'tools.recalculate',
                defaultMessage: 'Re-calculate',
              })}
            </Button>
          </Stack>
        </Container>
      ) : (
        <Container size="sm">
          <Stack sx={{ gap: 32 }}>
            <Flex justify={'center'}>
              <SharePopupNew.BottomNavHorizonal
                shareUrl={toolLink}
                showFull
                iconSize={24}
                styles={{
                  heading: {
                    fontSize: 12,
                  },
                }}
              />
            </Flex>
            {/* <div className="inline-button"> */}
            <SimpleGrid cols={2}>
              {onSave && (
                <Button size="lg" onClick={onSave} {...tracking?.save}>
                  {saveLabel || 'Save'}
                </Button>
              )}
              <Button
                size="lg"
                color="secondary"
                onClick={onRecalculate}
                {...tracking?.reCalculate}
              >
                {f({
                  id: 'tools.recalculate',
                  defaultMessage: 'Re-calculate',
                })}
              </Button>
            </SimpleGrid>
          </Stack>

          {/* </div> */}
        </Container>
      )}
    </>
  )
}

export default HealthToolButtonGroup
